<template>
  <v-container fluid>
    <v-card class="elevation-2 py-0 px-2 mt-4 rounded-lg">
      <v-row class="px-4 pb-0 pt-3">
        <v-col cols="10" md="5" class="pb-0">
          <v-text-field
            dense
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            outlined
          ></v-text-field>
        </v-col>
        <v-btn 
          color="#3F51B5" 
          class="mt-3" 
          dark 
          depressed 
          height='40'
          max-width='40'
          min-width='40'
          @click="cleanFilters"
        >
        <v-icon>
            mdi-autorenew
        </v-icon>
      </v-btn>
      </v-row>
      <v-row  class="px-7 pb-0 pt-6">
        <v-col cols="10" md="5" class="pa-0 mr-auto">
          <v-autocomplete
            dense
            v-model="filtered.external_keyword_source"
            :items="filters.leadSourceFilter"
            :menu-props="{ maxHeight: '200' }"
            multiple
            hint="Order Lead Source Filter"
            outlined
            :class="{'v-input--is-focused primary--text' : filtered.external_keyword_source.length}"
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index < ($vuetify.breakpoint.xs ? 2 : 3)" text-color="grey darken-4" class="grey lighten-3">
                <span>{{ item }}</span>
              </v-chip>
              <span
                v-if="index === ($vuetify.breakpoint.xs ? 2 : 3)"
                class="grey--text chip-counter"
              >
                (+{{ filtered.external_keyword_source.length - ($vuetify.breakpoint.xs ? 2 : 3) }} {{ (filtered.external_keyword_source.length - ($vuetify.breakpoint.xs ? 2 : 3)) > 1 ? 'others' : 'another' }})
              </span>
            </template>
            <template v-slot:label>
              <p :class="filtered.external_keyword_source.length ? 'primary--text' : ''">Order Lead Source</p>
            </template>          
          </v-autocomplete>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="elevation-2 py-1 px-0 mt-4 rounded-lg">
      <v-dialog
        v-model="dialog"
        max-width="500px"
      >
        <v-card>
          <v-card-title class="headline">
            Edit Mapping
          </v-card-title>
          <v-card-text>
            <v-text-field
              :value="editedItem.external_campaign_name"
              label="Order Lead Campaign"
              readonly
            ></v-text-field>
            <v-autocomplete
              v-model="campaignId"
              :items="campaigns"
              item-text="campaignName"
              item-value="campaignId"
              label="Internal Campaign"
              :placeholder="editedItem.campaignName"
            >
            </v-autocomplete>
            <v-text-field
              :value="editedItem.external_keyword_text"
              label="Order Lead Keyword"
              readonly
            ></v-text-field>
            <v-autocomplete
              v-model="internalKeywordId"
              :items="selected"
              item-text="text"
              item-value="internal_keyword_id"
              label="Internal Keyword"
              :placeholder="editedItem.internal_keyword_text"
            ></v-autocomplete>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click="close"
            >
              Cancel
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              :disabled="!campaignId"
              @click="editMapping"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-hover v-model="hoverOnTable">
        <v-card-text>
          <div class="d-flex justify-space-between">        
            <v-btn
              class="mx-2 scroll-btn btn-left"
              fab
              small     
              @click="scrollingLeft"
            >
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
            <v-btn
              class="mx-2 scroll-btn btn-right"
              fab
              small
              @click="scrollingRight"
            >
              <v-icon>
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </div>
          <v-data-table
            loading-text="Loading... Please wait"
            :loading="loaded"
            :headers="headersMapping"
            :items="dataFiltered"
            item-key="id"
            class="elevation-0 mt-2 table-main-container"
            :search="search"
            :page.sync="pagination.page"
            :footer-props="{
              'items-per-page-options': [10, 25, 50, 75, 100, -1]
              }"
            @click:row="rowClick"
          >
            <template v-slot:item.actions="{ item }" v-if="role == 'Admin' || managementRight">
              <v-icon
                small
                class="mr-2"
                @click="editItem(item)"
              >
                mdi-pencil
              </v-icon>
            </template>
          </v-data-table>
        </v-card-text>
      </v-hover>
    </v-card>
  </v-container>
</template>

<script>
import axios from '@/api/axios-auth'

export default {
  data() {
    return {
      hideAnything: false,
      data: {},
      loaded: false,
      mapping: [],
      campaigns: [],
      search: '',
      filtered: {
        'external_keyword_source': [],
      },
      filters: {
        'leadSourceFilter': [],
      },
      headersMapping: [
        {text: 'Mapping ID', value: 'id', class: 'black--text'},
        {text: 'Order Lead Source', value: 'external_keyword_source', class: 'black--text'},
        {text: 'Order Lead Campaign', value: 'external_campaign_name', class: 'black--text'},
        {text: 'Order Lead  Keyword', value: 'external_keyword_text', class: 'black--text'},
        {text: 'Internal Keyword Id', value: 'internal_keyword_id', class: 'black--text'},
        {text: 'Internal Keyword Source (Google Ads or Bing Ads)', value: 'internal_keyword_source', class: 'black--text'},
        {text: 'Internal Campaign', value: 'campaignName', class: 'black--text'},
        {text: 'Internal Keyword', value: 'internal_keyword_text', class: 'black--text'},
        {text: 'Actions', value: 'actions', class: 'black--text', sortable: false},
      ],
      googleKeywordIds: [
        {id: '900000001', keyword: 'Campaign w/o keyword (google)'},
        {id: '900000002', keyword: 'Keyword w/o campaign (google)'},
        {id: '900000003', keyword: 'Campaign w/o keyword'},
        {id: '900000004', keyword: 'Keyword w/o campaign'},
        {id: '900000005', keyword: 'No keyword and campaign'},
      ],
      dialog: false,
      editedIndex: -1,
      editedItem: {
        campaign_id: null,
        external_campaign_name: '',
        campaignName: null,
        id: null,
      },
      campaignId: null,
      selected: [],
      internalKeywordId: null,
      keywords: [],
      managementRight: false,
      rights: [],
      role: null,
      scrollLeft: 0,
      scrollWidth: 0,
      clientWidth: 0,
      hoverOnTable: false,
      pagination: {
        page: 1
      }
    }
  },
  watch: {
    campaignId: function (val) {
      this.fetchCampaign(val)
    },
    hoverOnTable(){
      this.showScrollingArrows()
    },
    dataFiltered(){
      this.pagination.page = 1
    },
  },
  computed: {
    dataFiltered() {
      return this.mapping.filter(d => {
        this.loaded = false
        return Object.keys(this.filtered).every(f => {
          return this.filtered[f].length < 1 || this.filtered[f].includes(d[f])
        })
      })
    },
  },
  created() {
    window.addEventListener("resize", this.showScrollingArrows)
  },
  destroyed() {
    window.removeEventListener("resize", this.showScrollingArrows)
  },
  mounted() {
    this.loaded = true

    axios
      .get('/users/me')
      .then(response => {
        this.role = response.data.data.role
        this.rights = response.data.data.rights
        this.managementRight = (this.rights == {}) ? false : this.rights.includes('keywordMapping')
      })

    axios
        .get('/all/campaigns')
        .then(response => (this.campaigns = response.data.data))

    axios
        .get('/keywords')
        .then(response => {
          this.keywords = response.data.data
          this.getMapping()
        })

    this.showScrollingArrows()
  },
  methods: {
    scrollingRight(){
      const el = document.querySelector('.v-data-table__wrapper')

      el.scrollLeft = el.scrollLeft + 50

      const btnRight = document.querySelector('.btn-right')
      const btnLeft = document.querySelector('.btn-left')
      btnRight.style.visibility = (this.hoverOnTable && (el.scrollLeft + el.clientWidth != el.scrollWidth)) ? 'visible' : 'hidden'
      btnLeft.style.visibility = this.hoverOnTable ? 'visible' : 'hidden'
    },
    scrollingLeft(){
      const el = document.querySelector('.v-data-table__wrapper')

      el.scrollLeft = el.scrollLeft - 50

      const btnLeft = document.querySelector('.btn-left')
      const btnRight = document.querySelector('.btn-right')
      btnLeft.style.visibility = (this.hoverOnTable && (el.scrollLeft != 0)) ? 'visible' : 'hidden'
      btnRight.style.visibility = this.hoverOnTable ? 'visible' : 'hidden'
    },
    showScrollingArrows(){
      const el = document.querySelector('.v-data-table__wrapper')
      this.scrollLeft = el.scrollLeft
      this.scrollWidth = el.scrollWidth
      this.clientWidth = el.clientWidth

      const btnRight = document.querySelector('.btn-right')
      const btnLeft = document.querySelector('.btn-left')
      btnRight.style.visibility = (this.hoverOnTable && (this.scrollLeft + this.clientWidth !== this.scrollWidth)) ? 'visible' : 'hidden'
      btnLeft.style.visibility = (this.hoverOnTable && (this.scrollLeft != 0)) ? 'visible' : 'hidden'
    },
    fetchFilters() {
      this.filters.leadSourceFilter = this._.compact(this.mapping
          .map(e => e.external_keyword_source)
          .filter((x, i, a) => a.indexOf(x) == i))
          .sort((a, b) => a.localeCompare(b))
    },
    fetchCampaign(val) {
      if (val == null) {
        return
      }

      this.selected = [
        {internal_keyword_id: '900000001', text: 'Campaign w/o keyword (google)'},
        {internal_keyword_id: '900000002', text: 'Keyword w/o campaign (google)'},
        {internal_keyword_id: '900000003', text: 'Campaign w/o keyword'},
        {internal_keyword_id: '900000004', text: 'Keyword w/o campaign'},
        {internal_keyword_id: '900000005', text: 'No keyword and campaign'},
      ]
      axios
          .get(`/all/keyword/${val}`)
          .then(response => {
            let keywords = response.data.data.map((value) => ({
              internal_keyword_id: value.internal_keyword_id,
              text: value.keyword_text
            }))

            this.selected = [...this.selected, ...keywords]
          })
    },
    editItem(item) {
      this.editedIndex = this.mapping.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    getMapping() {
      axios
          .get('/mappings/campaigns')
          .then(response => {
            this.mapping = response.data.data
            this.googleKeywordIds.map(e => {
              this.mapping.map(campaign => {
                campaign.external_keyword_text = (campaign.internal_keyword_id == e.id)
                    ? e.keyword
                    : campaign.external_keyword_text
              })
            })

            this.campaigns.forEach(campaign => {
              this.mapping.map(e => {
                if (e.campaign_id == campaign.campaignId) {
                  e.campaignName = campaign.campaignName
                }
              })
            });

            this.keywords.forEach(keyword => {
              this.mapping.map(e => {
                if (e.internal_keyword_id == keyword.internal_keyword_id) {
                  e.internal_keyword_text = keyword.text
                }
              })
            });
            this.mapping.map(e => {
              if (e.external_campaign_name == "") {
                e.external_campaign_name = "-"
              }
            })
            this.mapping.map(e => {
              e.internal_keyword_source = (e.internal_keyword_id > 0)
                  ? e.internal_keyword_source : ''
            })

            this.fetchFilters()
          })
    },
    editMapping() {
      let internalKeywordId = (!this.internalKeywordId) ? this.editedItem.internal_keyword_id : this.internalKeywordId
      axios
          .put('/mappings/campaigns/' + this.editedItem.id + '/' + this.campaignId + '/' + internalKeywordId)
          this.mapping
            .find(e => e.campaign_id === this.editedItem.campaign_id).campaignName = this.campaigns
            .find(e => e.campaignId === this.campaignId).campaignName
          this.getMapping()
          this.internalKeywordId = null
          this.campaignId = null
          this.dialog = false
    },
    close() {
      this.internalKeywordId = null
      this.campaignId = null
      this.dialog = false
    },
    cleanFilters(){
      this.search = ''
      this.filtered.external_keyword_source = []
    },
    rowClick: function (item, row) {     
      let selectState = (row.isSelected) ? false : true
      row.select(selectState)
    }
  }
}
</script>

<style scoped>

</style>